import { z } from 'zod';
import { colorSchema } from './common.js';
import { RESOURCE_KINDS } from '../content/index.js';
/** Иконка вида «библиотека:имя» (lucide, tabler, ph). */
export const iconSchema = z.string().regex(/^(lucide|tabler|ph):[a-z0-9-]{1,64}$/, 'Иконка вида lucide:folder');
export const createProjectSchema = z.object({
    name: z.string().trim().min(1).max(160),
    description: z.string().trim().max(1000).default(''),
    type: z.enum(['project', 'site']).default('project'),
    icon: iconSchema.default('lucide:folder'),
    color: colorSchema.default('#f7701f'),
    visibility: z.enum(['space', 'restricted']).default('space'),
    template: z.string().max(40).default('blank'),
});
export const updateProjectSchema = z
    .object({
    name: z.string().trim().min(1).max(160),
    description: z.string().trim().max(1000),
    icon: iconSchema,
    color: colorSchema,
    aiEnabled: z.boolean(),
})
    .partial();
export const deleteProjectSchema = z.object({ confirmName: z.string().trim().min(1).max(160) });
const grant = (perms) => z.object({ userId: z.uuid(), permission: z.enum(perms) });
export const projectAccessSchema = z.object({
    visibility: z.enum(['space', 'restricted']),
    /** Полная замена списка грантов проекта. */
    grants: z.array(grant(['view', 'edit', 'manage'])).max(500),
});
/** Положение карточки; grid — карточка папки на bento-главной (раскладка сеткой). */
const position = z.object({
    x: z.number().finite().min(-1e5).max(1e5),
    y: z.number().finite().min(-1e5).max(1e5),
    grid: z.boolean().optional(),
});
const title = z.string().trim().min(1, 'Укажите название').max(160);
export const createResourceSchema = z.object({
    kind: z.enum(RESOURCE_KINDS),
    title,
    parentId: z.uuid().nullable().default(null),
    personal: z.boolean().default(false),
    content: z.unknown().optional(),
    position: position.nullable().optional(),
});
export const patchResourceSchema = z
    .object({
    version: z.number().int().positive(),
    title: title.optional(),
    content: z.unknown().optional(),
    personal: z.boolean().optional(),
    /** Подтверждение, что пользователь видел предпросмотр изменения аудитории (для смены personal). */
    confirmAccessChange: z.boolean().optional(),
})
    .refine((v) => v.title !== undefined || v.content !== undefined || v.personal !== undefined, 'Нечего менять');
export const moveResourceSchema = z.object({
    version: z.number().int().positive(),
    parentId: z.uuid().nullable(),
});
/** Положение карточки на холсте: без версии (последняя запись побеждает) — перетаскивание не конфликтует с правкой текста. */
export const positionSchema = position;
export const versionSchema = z.object({ version: z.number().int().positive() });
export const resourceAccessSchema = z.object({
    version: z.number().int().positive(),
    grants: z.array(grant(['view', 'edit'])).max(500),
});
export const createMetricSchema = z.object({
    name: z.string().trim().min(1).max(160),
    unit: z.string().trim().max(30).default(''),
    target: z.number().finite().positive(),
    actual: z.number().finite().default(0),
    period: z.string().trim().min(1).max(100),
});
export const patchMetricSchema = z
    .object({
    version: z.number().int().positive(),
    name: z.string().trim().min(1).max(160).optional(),
    unit: z.string().trim().max(30).optional(),
    target: z.number().finite().positive().optional(),
    period: z.string().trim().min(1).max(100).optional(),
    actual: z.number().finite().optional(),
})
    .refine((v) => Object.keys(v).length > 1, 'Нечего менять');
/** AI-предложение связи: принять (станет связью графа) или скрыть. */
export const patchLinkSchema = z.object({ state: z.enum(['accepted', 'dismissed']) });
//# sourceMappingURL=projects.js.map